(function (global, factory) {
  typeof exports === 'object' && typeof module !== 'undefined' ? factory(exports) :
  typeof define === 'function' && define.amd ? define(['exports'], factory) :
  (global = global || self, factory(global.safeFocusInit = {}));
}(this, (function (exports) { 'use strict';

  var safeFocusClass = 'safe-focus';

  var cutsTheMustard = function cutsTheMustard() {
    return !!document.documentElement.classList;
  };

  var htmlEl;
  /**
   *  Assign the HTML element after the init function has run.
   *  @return {undefined}
   */

  var assignHtml = function assignHtml() {
    htmlEl = document.documentElement;
  };
  /**
   *  Add class to key off of for showing focus outlines
   *  @return {undefined}
   */


  var activateSafeFocus = function activateSafeFocus() {
    htmlEl.classList.add(safeFocusClass);
  };
  /**
   *  Remove class to key off of for showing focus outlines
   *  @return {undefined}
   */


  var deactivateSafeFocus = function deactivateSafeFocus() {
    htmlEl.classList.remove(safeFocusClass);
  };
  /**
   *  Bind events for adding & removing class to key off of for showing focus outlines
   *  @return {undefined}
   */


  var safeFocusInit = function safeFocusInit() {
    assignHtml();

    if (cutsTheMustard()) {
      htmlEl.classList.remove(safeFocusClass);
      document.addEventListener('mousedown', deactivateSafeFocus);
      document.addEventListener('keydown', activateSafeFocus);
    }
  };

  exports.safeFocusClass = safeFocusClass;
  exports.safeFocusInit = safeFocusInit;

  Object.defineProperty(exports, '__esModule', { value: true });

})));
